const Scroll = (props) => (
  <svg width='17' height='65' viewBox='0 0 17 65' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.899249' y='38.2793' width='15.3087' height='25.8663' rx='7.65433' stroke='white' strokeWidth='1.58365' />
    <path d='M8.55347 43.5581V49.8927' stroke='white' strokeWidth='1.58365' strokeLinecap='round' />
    <path
      d='M8.55347 30.625L8.55347 1.5'
      stroke='white'
      strokeWidth='1.28873'
      strokeLinecap='round'
      strokeDasharray='4.22 4.22'
    />
  </svg>
);

export default Scroll;
